import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatTableColumn, TableInfo } from '../mat-table/mat-table.component';

@Component({
  selector: 'mat-table-paginated',
  templateUrl: './mat-table-paginated.component.html',
  styleUrls: ['./mat-table-paginated.component.scss']
})
export class MatTablePaginatedComponent implements OnInit {
  @Input() tableColumns: MatTableColumn[] = [];
  @Input() tableData: any[] = [];
  @Input() tableInfo: TableInfo;


  displayedColumns: string[];
  dataSource = new MatTableDataSource();

  constructor() {}

  ngOnInit(): void {
    this.displayedColumns = this.tableColumns.map(column => column.columnDef);
    this.dataSource.data = this.tableData;
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }

}
